import React from 'react'
import styles from './CAEJSummary.module.css'

const CAEJSummary = () => {
    return (
        <div>CAEJSummary</div>
    )
}

export default CAEJSummary